import axios from 'axios';

const register = (user) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/user/register`,
    {
      email: user.email,
      password: user.password
    }
  );
}

const checkRegistration = (user) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/api/user/isregistered`,
    {
      params: {
        email: user.email
      }
    }
  );
}

const sendPasswordReset = (email) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/user/resetpasswordrequest`,
    null,
    {
      params: {
        email
      }
    }
  );
}

const resetPassword = (user) => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/api/user/resetpassword`,
    user
  );
}

export const userService = {
  checkRegistration,
  register,
  sendPasswordReset,
  resetPassword
}
